import { InstallationStatus } from "@/model/data/status/InstallationStatus";
import { MaintenanceStatusEnum } from "@/model/data/status/MaintenanceStatusEnum";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class FetchInstallationsPreventiveMaintenanceStatusResponse extends ApiGenericResponse {
    installationsList: InstallationStatus[];
    totalInstallationsCount: number;
    totalCountByStatus: Map<MaintenanceStatusEnum, number>;
    filteredTotalCountByStatus: Map<MaintenanceStatusEnum, number>;

    constructor(response: AxiosResponse) {
        super(response);
        this.installationsList = [];
        this.totalInstallationsCount = 0;
        this.totalCountByStatus = new Map<MaintenanceStatusEnum, number>();
        this.filteredTotalCountByStatus = new Map<MaintenanceStatusEnum, number>();
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsStatus && obj.InstallationsStatus.length > 0) {
            obj.InstallationsStatus.forEach((e) => {
                let inst = new InstallationStatus();
                inst.parse(e);
                this.installationsList.push(inst);
            });
        }
        if (obj.TotalDeviceStatusCount) this.totalInstallationsCount = obj.TotalDeviceStatusCount;

        if (obj.TotalCountByStatus) {
            for (let key in obj.TotalCountByStatus) {
                if (key != null && Object.values(MaintenanceStatusEnum).includes(key)) {
                    this.totalCountByStatus.set(MaintenanceStatusEnum[key], obj.TotalCountByStatus[key]);
                }
            }
        }
        if (obj.FilteredTotalCountByStatus) {
            for (let key in obj.FilteredTotalCountByStatus) {
                if (key != null && Object.values(MaintenanceStatusEnum).includes(key)) {
                    this.filteredTotalCountByStatus.set(MaintenanceStatusEnum[key], obj.FilteredTotalCountByStatus[key]);
                }
            }
        }
    }
}

export class TotalByStatus {
    installationStatus: MaintenanceStatusEnum;
    total: number;

    constructor(installationStatus: string, total: number) {
        this.installationStatus = MaintenanceStatusEnum[installationStatus];
        this.total = total;
    }
}
